<template>
<n-card
    v-if="show"
    size="small"
    role="dialog"
    aria-modal="true"
    header-style="padding: 8px 12px;"
    class="rounded-md fixed bottom-[58px] w-[96%] left-1/2 -translate-x-1/2 z-[999] shadow-xl"
    :class="[lightDark ? 'bg-white dark:bg-darkCardBg' : 'bg-white dark:bg-darkCardBg']"
    :segmented="{
      content: true,
      footer: 'soft'
    }"
    content-style="max-height: 150px; oveflow-y-auto">
    <template #header>
        <div class="text-left text-main py-1 text-xs">{{ gl.postAdviceMessages[page - 1].title }}</div>
    </template>
    <template #default>
        <div class="text-left notes text-[10px]" v-html="gl.postAdviceMessages[page - 1].msg"></div>
    </template>
    <template #footer>
        <div class="flex justify-between items-center">
            <n-pagination size="small" v-model:page="page" :page-slot="3" :page-count="gl.postAdviceMessages?.length" />
            <div class="flex">
                <n-button
                    size="small"
                    class="text-white/90 rounded-md"
                    :color="gl.mainColor"
                    @click="adviceMessageMarkAsRead(gl.postAdviceMessages[page - 1])">
                    {{ refs.localization.dialogs.read }}
                </n-button>
                <n-button
                    size="small"
                    class="text-gray-600 dark:text-white/75 rounded-md ml-2"
                    @click="close">
                    {{ refs.localization.dialogs.close }}
                </n-button>
            </div>
        </div>
    </template>
</n-card>
</template>

<script>
// vue
import { ref, computed, watch } from 'vue';

// store
import { useGl } from '@store/ts/gl';
import { useRefs } from '@store/ts/refs';

// i18n
import { useI18n } from 'vue-i18n';

// services
import ProfileService from '@services/profileService';

// naive-ui
import {
    NIcon,
    NCard,
    NModal,
    NButton,
    NPagination,
    useNotification } from 'naive-ui';

// icons
import { Dismiss16Filled } from '@vicons/fluent';

export default {
    name: 'post-advice-message-mobile',
    props: {
        label: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            default: '600px',
        },
        height: {
            type: Number, String,
        },
        maskClosable: {
            type: Boolean,
            default: true,
        },
        showCLoseButton: {
            type: Boolean,
            default: true,
        },
        lightDark: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        NIcon,
        NCard,
        NModal,
        NButton,
        NPagination,
        Dismiss16Filled,
    },
    setup() {
        // store
        const gl = useGl();
        const refs = useRefs();

        // ui
        const notification = useNotification();

        // vars
        const page = ref(1);

        // i18n
        const { t } = useI18n();

        const show = computed(() => !!gl.postAdviceMessages && gl.postAdviceMessages?.length);

        watch(show, () => {
            page.value = 1;
        });

        const close = () => {
            gl.postAdviceMessages = null;

            try {
                ProfileService.adviceMessageDeferAll({ defer: true });
            } catch {
                notification.error({
                    content: t('errorMessage'),
                    duration: 2500,
                    keepAliveOnHover: true,
                });
            };
        };

        const adviceMessageMarkAsRead = async el => {
            try {
                if (el.need_feedback)
                    ProfileService.adviceMessageMarkAsRead({ id: el.id });

                const i = gl.postAdviceMessages.findIndex(item => item.id === el.id);

                gl.postAdviceMessages.splice(i, 1);

                if (!gl.postAdviceMessages.length) {
                    close();
                }
            } catch {
                notification.error({
                    content: t('errorMessage'),
                    duration: 2500,
                    keepAliveOnHover: true,
                });
            };
        };

        return {
            gl,
            refs,
            page,
            show,
            close,
            adviceMessageMarkAsRead,
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(a) {
    color: #1A6DE0 !important;
}

:deep(b) {
    color: #1A6DE0 !important;
}

:deep(.n-card__content) {
    overflow-y: auto;
}
</style>